import { useTranslation } from 'react-i18next';

import { Wrapper, EmojiWrapper, Title, Description, TextWrapper } from '../EmptyMessages.styles';

export const EmptyTasks: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');

  return (
    <Wrapper>
      <EmojiWrapper>
        <span role="img" aria-label="meditation">
          🧘
        </span>
      </EmojiWrapper>
      <TextWrapper>
        <Title>{t('EMPTY_TASKS_TITLE')}</Title>
        <Description>{t('EMPTY_TASKS_DESCRIPTION')}</Description>
      </TextWrapper>
    </Wrapper>
  );
};
